export default "__VITE_ASSET__f01b5989__"